import { serialize } from "next-mdx-remote/serialize";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import rehypeHighlight from "rehype-highlight";
import GithubSlugger from "github-slugger";
import { unified } from "unified";
import remarkParse from "remark-parse";
import { visit } from "unist-util-visit";
import { type SidebarHeading } from "components/sidebar";
import remarkSectionize from "remark-sectionize";

/**
 * Extracts all the H2 headings from the markdown content and turns them into
 * object that can be used to build the sidebar links.
 */
export function getArticleHeadings(content: string): SidebarHeading[] {
  const slugger = new GithubSlugger();
  const tree = unified().use(remarkParse).parse(content);
  const headings: SidebarHeading[] = [];

  visit(tree, "heading", (node) => {
    if (node.depth === 2) {
      const title = content
        .slice(node.position?.start.offset ?? 0, node.position?.end.offset ?? 0)
        .replace(/^#+/g, "")
        .trim();

      headings.push({
        title,
        href: `#${slugger.slug(title)}`,
      });
    }
  });

  return headings;
}

export async function serializeArticle(content: string, includeSectionizePlugin?: boolean) {
  const mdx = await serialize(content, {
    mdxOptions: {
      rehypePlugins: [rehypeSlug, rehypeHighlight],
      remarkPlugins: includeSectionizePlugin ? [remarkSectionize, remarkGfm] : [remarkGfm],
      format: "mdx",
    },
  });

  return mdx;
}
